import {
  OrderIncompleteDeliveryCreateRequest as ApiOrderIncompleteDeliveryCreateRequest,
  OrderIncompleteDeliveryReason as ApiOrderIncompleteDeliveryReason,
  OrderUnresolvedIncompleteDelivery as ApiOrderUnresolvedIncompleteDelivery,
} from '@/gen/api';
import {
  OrderIncompleteDeliveryReason,
  OrderIncompleteDeliveryReport,
  OrderUnresolvedIncompleteDelivery,
} from '@/models/OrderIncompleteDelivery';

export const parseOrderIncompleteDeliveryReason = (
  reason: string,
): OrderIncompleteDeliveryReason | undefined => {
  switch (reason.toUpperCase()) {
    case OrderIncompleteDeliveryReason.ItemsMissing:
      return OrderIncompleteDeliveryReason.ItemsMissing;
    case OrderIncompleteDeliveryReason.ItemDamaged:
      return OrderIncompleteDeliveryReason.ItemDamaged;
    case OrderIncompleteDeliveryReason.Other:
      return OrderIncompleteDeliveryReason.Other;
    default:
      return undefined;
  }
};

const toApiOrderIncompleteDeliveryReason = (
  reason: OrderIncompleteDeliveryReason,
): ApiOrderIncompleteDeliveryReason => {
  switch (reason) {
    case OrderIncompleteDeliveryReason.ItemsMissing:
      return ApiOrderIncompleteDeliveryReason.ItemsMissing;
    case OrderIncompleteDeliveryReason.ItemDamaged:
      return ApiOrderIncompleteDeliveryReason.ItemDamaged;
    case OrderIncompleteDeliveryReason.Other:
      return ApiOrderIncompleteDeliveryReason.Other;
  }
};

export const toApiOrderIncompleteDeliveryCreateRequest = (
  report: OrderIncompleteDeliveryReport,
): ApiOrderIncompleteDeliveryCreateRequest => ({
  reason: toApiOrderIncompleteDeliveryReason(report.reason),
  comment: report.comment,
});

export const toOrderUnresolvedIncompleteDelivery = (
  incompleteDelivery: ApiOrderUnresolvedIncompleteDelivery | null | undefined,
): OrderUnresolvedIncompleteDelivery | null | undefined => {
  if (incompleteDelivery === null || incompleteDelivery === undefined) {
    return incompleteDelivery;
  }

  const reason = parseOrderIncompleteDeliveryReason(incompleteDelivery.reason);

  if (reason === undefined) {
    return undefined;
  }

  return {
    id: incompleteDelivery.id,
    reason,
    comment: incompleteDelivery.comment,
  };
};
